import { Box, type SystemStyleObject } from "@chakra-ui/react";
import { Select, useChakraSelectProps } from "chakra-react-select";
import { useTranslation } from "react-i18next";

export interface MultiSelectOption {
  label: string;
  value: string;
}

interface Props {
  placeholder: string;
  options: {
    value: string;
    label: string;
  }[];
  value: MultiSelectOption[];
  onChange: (values: MultiSelectOption[]) => void;
}

export const MultiSelectFilter = ({ placeholder, options, value, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Select<MultiSelectOption>
      {...useChakraSelectProps<MultiSelectOption>({
        size: "sm",
        isMulti: true,
        value: value,
        onChange: (selectedOptions: MultiSelectOption[]) => {
          onChange(
            selectedOptions.map((option: MultiSelectOption) => ({
              label: option.label,
              value: option.value,
            }))
          );
        },
        isClearable: false,
        selectedOptionStyle: "check",
        selectedOptionColor: "blue",
        placeholder: <Box color={"smMuted"}>{placeholder}</Box>,
        noOptionsMessage: () => <Box>{t("No available options")}</Box>,
      })}
      options={options}
      chakraStyles={{
        control: (provided: SystemStyleObject) => ({
          ...provided,
          backgroundColor: "smBackground",
          rounded: "md",
        }),
        container: (provided: SystemStyleObject) => ({
          ...provided,
          backgroundColor: "smBackground",
          borderColor: "smBorder",
          width: "full",
        }),
        menuList: (provided: SystemStyleObject) => ({
          ...provided,
          rounded: "md",
        }),
      }}
    />
  );
};
